import { Button, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { DataTable } from "@/components/tables";
import { ComponentLoader } from "@/components/loader";
import useNotifications from "../notifications/useNotifications";
import { NotificationChannelsProps, NotificationChannel } from "../../types";
import { TableHeaderType } from "@/components/tables/types";
import NoChannels from "./NoChannels";

const NotificationChannels = ({ toggleAddNotificationChannel }: NotificationChannelsProps) => {
  const { data, isLoading } = useNotifications();

  const channels: NotificationChannel[] =
    data?.notifications?.map(n => {
      return {
        id: n?.id || "",
        name: n.config?.name || "",
        type: n?.type || "",
      };
    }) ?? [];

  if (isLoading) return <ComponentLoader label="Loading notification channels" />;

  // Webhook URLs are secrets — the backend redacts them from GET responses.
  // Admins manage channels by name/type; to rotate a URL, delete and re-add.
  const header: TableHeaderType<NotificationChannel>[] = [
    {
      id: 1,
      uid: "name",
      label: "Name",
      render: (item: NotificationChannel) => <div className="al-truncate">{item.name}</div>,
    },
    {
      id: 2,
      uid: "type",
      label: "Type",
      width: 150,
      render: (item: NotificationChannel) => <div>{item.type}</div>,
    },
  ];

  return (
    <section aria-label="Notification channels management">
      <Stack direction="row" align="center" justify="between" className="al-mb-4">
        <Typography variant="page-heading">Notification Channels</Typography>
        <Button onClick={toggleAddNotificationChannel}>Add notification channel</Button>
      </Stack>
      {channels.length === 0 ? (
        <NoChannels toggleAddNotificationChannel={toggleAddNotificationChannel} />
      ) : (
        <DataTable header={header} data={{ items: channels }} />
      )}
    </section>
  );
};

export default NotificationChannels;
